import { InfoOutlined } from '@mui/icons-material';
import { EventStatusEnum } from 'domain/event/EventStatusEnum';
import { Title } from 'primary/Components/Title/Title';
import { ClassementParticipantDatataleParameters } from 'primary/events/datatable/ClassementParticipantDatatableParameters';
import { EventViewPageContext } from 'primary/events/item/EventViewPage';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';
import { useOutletContext } from 'react-router-dom';

export const ClassementView = () => {
  const { event } = useOutletContext<EventViewPageContext>();
  const t = useTranslate();
  if (!event) return null;
  return (
    <div className={'classement'}>
      <Title
        title={t('event.parameters.classement.title')}
        level={1}
        compensatePadding
        threeQuarter
        bordered
      />
      {[EventStatusEnum.DRAFT, EventStatusEnum.PUBLISH].includes(event.status) && (
        <div className={'-infosWithText'}>
          <InfoOutlined />
          <span>{t('eventNotBegun')}</span>
        </div>
      )}
      {![EventStatusEnum.DRAFT, EventStatusEnum.PUBLISH].includes(event.status) && (
        <>
          <ClassementParticipantDatataleParameters event={event} />
        </>
      )}
    </div>
  );
};
